// src/pages/History/RenaissanceReformation/ProtestantReformation.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Renaissance_&_Reformation_-_Protestant_Reformation.png';

export default function HistoryPageProtestantReformation() {
  return (
    <TopicPage
      topicKey="Protestant Reformation"
      title="History: Protestant Reformation"
      backgroundImage={bg}
      startRoute="/History-Protestant-Reformation-Go"
      scrollLabels={[
        "Martin Luther and the 95 Theses",
        "Spread of Protestantism",
        "Political and Religious Impacts",
      ]}
      backRoute="/history-renaissance"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
